/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventneedspublichost3Inputs */

const en_eventneedspublichost3 = /** @type {(inputs: Eventneedspublichost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish this event's profile first.`)
};

const de_eventneedspublichost3 = /** @type {(inputs: Eventneedspublichost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentliche zuerst das Profil dieses Events.`)
};

/**
* | output |
* | --- |
* | "Publish this event's profile first." |
*
* @param {Eventneedspublichost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventneedspublichost3 = /** @type {((inputs?: Eventneedspublichost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventneedspublichost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventneedspublichost3(inputs)
	return de_eventneedspublichost3(inputs)
});
export { eventneedspublichost3 as "eventNeedsPublicHost" }